import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ModeProvider, useMode } from "./contexts/ModeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";

// Lazy-loaded pages for code splitting (only Home is eager)
const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/DashboardNew"));
const AuthCallback = lazy(() => import("./pages/AuthCallback"));
const RemoteAccess = lazy(() => import("./pages/RemoteAccess"));
const TrialSuccess = lazy(() => import("./pages/TrialSuccess"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

const AppContent = () => {
  const location = useLocation();
  const { isLabs } = useMode();

  if (location.hash?.includes('session_id=')) {
    return (
      <Suspense fallback={<PageLoader />}>
        <AuthCallback />
      </Suspense>
    );
  }

  const isAuthPage = location.pathname === '/login' || location.pathname === '/auth/callback';
  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/remote-access';
  const showHeader = !isAuthPage && !isDashboard;
  const showFooter = !isAuthPage && !isDashboard;

  return (
    <div className={isLabs ? 'labs-mode' : 'callup-mode'}>
      {showHeader && <Header />}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/remote-access" element={<RemoteAccess />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/trial-success" element={<TrialSuccess />} />
        </Routes>
      </Suspense>
      {showFooter && <Footer />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ModeProvider>
            <AppContent />
          </ModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
